// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UyGARBfyjlePlW {
  display: flex;
  position: relative;
  flex-wrap: nowrap;
  align-items: flex-start;
  max-width: 100%;
  min-height: 32px;
}
.PZW81xJplYqHGN {
  flex: 1 1 20%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.z0eqWVVZWBQhjv {
  display: flex;
  position: relative;
  flex-wrap: nowrap;
  align-items: flex-start;
  min-height: 32px;
  margin-left: auto;
  gap: var(--ds-space-050, 4px);
}
.Tp0C38uQUEpYUw {
  display: inline-flex;
  position: relative;
  flex-direction: row;
  flex-grow: 1;
  flex-wrap: wrap;
  align-items: center;
  width: calc(100% - 23px);
  height: auto;
  padding: var(--ds-space-150, 12px);
  gap: var(--ds-space-050, 4px);
  container-name: boardHeader;
  container-type: inline-size;
}
@media only screen and (max-width: 900px) {
  .Tp0C38uQUEpYUw {
    flex-wrap: wrap;
  }
}
.jRVMQKpPkPcwIW {
  position: relative;
  height: 32px;
  margin: var(--ds-space-0, 0) var(--ds-space-100, 8px) var(--ds-space-0, 0) var(--ds-space-0, 0px);
  float: left;
  overflow: hidden;
  font-size: 14px;
  line-height: 32px;
  cursor: default;
}
.RunGqi_UL_Z4LR {
  flex-grow: 1;
}
.qS4WmrFQa0qtYU {
  display: flex;
  gap: var(--ds-space-050, 4px);
}
.Fhqnv8SYn4_3re {
  margin: var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var boardHeaderLeftSplit = `UyGARBfyjlePlW`;
export var boardHeaderLeftSplitNoOverflow = `PZW81xJplYqHGN`;
export var boardHeaderRightSplit = `z0eqWVVZWBQhjv`;
var _1 = `Tp0C38uQUEpYUw`;
export { _1 as "board-header" };
export var boardTemplateBadgeContainer = `jRVMQKpPkPcwIW`;
export var widthObserverContainer = `RunGqi_UL_Z4LR`;
export var actionsButtons = `qS4WmrFQa0qtYU`;
export var boardVisibilityButton = `Fhqnv8SYn4_3re`;
export default ___CSS_LOADER_EXPORT___;
